import { createSlice } from '@reduxjs/toolkit';
import { fetchTrimDetailsAsync } from './thunk';
import { IDLE_STATUS, LOADING_STATUS, MAX_TRIMS_COMPARE } from '../../../../../constants';
import { getLocalStorage, removeLocalStorage, setLocalStorage } from '../../../../../utils';
import { SELECTED_TRIMS_COMPARE_COOKIE_NAME } from '../../helpers/constant';

const { labels } = window.HONDAPS_FIND_AND_COMPARE_FOOTER;

const initialState = {
  status: {
    fetchTrimDetails: IDLE_STATUS,
  },
  errors: {
    isDifferentSegment: false,
    fetchTrimDetails: false,
  },
  globalInfo: { labels },
  selectedTrims: getLocalStorage(SELECTED_TRIMS_COMPARE_COOKIE_NAME) ? JSON.parse(getLocalStorage(SELECTED_TRIMS_COMPARE_COOKIE_NAME)) : [],
};

const findAndCompareFooter = createSlice({
  name: 'find-and-compare-footer',
  initialState,
  reducers: {
    clearSelectedTrims: (state) => {
      state.selectedTrims = [];
      state.errors.isMaxTrimsSelected = false;
      state.errors.isDifferentSegment = false;
      removeLocalStorage(SELECTED_TRIMS_COMPARE_COOKIE_NAME);
    },
    updateErrors: (state, { payload }) => {
      state.errors = { ...state.errors, ...payload };
    },
    addSelectedTrim: (state, { payload }) => {
      if (state.selectedTrims.length >= MAX_TRIMS_COMPARE) {
        return;
      }
      state.selectedTrims.push(payload);
    },
    removeSelectedTrim: (state, { payload }) => {
      state.selectedTrims = state.selectedTrims.filter((trim) => trim.modelId !== payload);
      if (state.selectedTrims.length === 0) {
        removeLocalStorage(SELECTED_TRIMS_COMPARE_COOKIE_NAME);
      } else {
        setLocalStorage(SELECTED_TRIMS_COMPARE_COOKIE_NAME, JSON.stringify(state.selectedTrims));
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTrimDetailsAsync.pending, (state) => {
        state.status.fetchTrimDetails = LOADING_STATUS;
        state.errors.fetchTrimDetails = false;
      })
      .addCase(fetchTrimDetailsAsync.rejected, (state) => {
        state.status.fetchTrimDetails = IDLE_STATUS;
        state.errors.fetchTrimDetails = true;
      })
      .addCase(fetchTrimDetailsAsync.fulfilled, (state, { payload }) => {
        state.status.fetchTrimDetails = IDLE_STATUS;
        state.errors.fetchTrimDetails = false;

        if (!state.selectedTrims.filter((trim) => !trim.loading).every((trim) => trim.vehicleType?.toLowerCase() === payload.segment?.toLowerCase())) {
          state.selectedTrims = state.selectedTrims.filter((trim) => !trim.loading);
          setLocalStorage(SELECTED_TRIMS_COMPARE_COOKIE_NAME, JSON.stringify(state.selectedTrims));
          state.errors.isDifferentSegment = true;
          return;
        }
        const index = state.selectedTrims.findIndex((trim) => trim.modelId === payload.id);
        if (index !== -1) {
          state.selectedTrims[index] = {
            vehicleType: payload.segment,
            modelId: payload.id,
            colorCode: payload.selectedColor?.mfgColorCode,
            productImage: payload.selectedColor?.image,
            name: payload.name,
            year: payload.year,
            msrp: payload.selectedColor?.actualMsrp,
            msrpDisclaimer: payload.msrpDisclaimer,
            destinationCharge: payload.destinationCharge,
          };
          setLocalStorage(SELECTED_TRIMS_COMPARE_COOKIE_NAME, JSON.stringify(state.selectedTrims));
          return;
        }
        if (state.selectedTrims.length >= MAX_TRIMS_COMPARE) {
          return;
        }
        state.selectedTrims.push({
          vehicleType: payload.segment,
          modelId: payload.id,
          colorCode: payload.selectedColor?.mfgColorCode,
          productImage: payload.selectedColor?.image,
          name: payload.name,
          year: payload.year,
          msrp: payload.selectedColor?.actualMsrp,
          msrpDisclaimer: payload.msrpDisclaimer,
          destinationCharge: payload.destinationCharge,
        });
        setLocalStorage(SELECTED_TRIMS_COMPARE_COOKIE_NAME, JSON.stringify(state.selectedTrims));
      });
  },
  selectors: {
    selectErrors: (state) => state.global?.errors,
    selectGlobalInfo: (state) => state.global?.globalInfo,
    selectIsShowFooter: (state) => state.global?.selectedTrims.length > 0 && state.global?.selectedTrims.some((trim) => !trim.loading),
    selectStatus: (state) => state.global?.status,
    selectSelectedTrims: (state) => state.global?.selectedTrims,
  },
});

export {
  fetchTrimDetailsAsync,
};

export const {
  clearSelectedTrims,
  updateErrors,
  addSelectedTrim,
  removeSelectedTrim,
} = findAndCompareFooter.actions;

export const {
  selectErrors,
  selectGlobalInfo,
  selectIsShowFooter,
  selectStatus,
  selectSelectedTrims,
} = findAndCompareFooter.getSelectors();

export default findAndCompareFooter.reducer;